var pageConfig = window.pageConfig;
var i18n = require('i18n');
var util = require('../../app/util');
var success;



var html = `<div class="ui modal small transfer-user-layer">
  <i class="close icon"></i>
  <div class="header">
    ${i18n('home.transfer.user')}
  </div>
  <div class="content">
    <div class="ui form">
      <div class="field">
        <label>${i18n('home.username')}</label>
        <div class="ui selection dropdown username">
          <input type="hidden" name="username">
          <i class="dropdown icon"></i>
          <div class="default text"></div>
          <div class="menu"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="actions">
    <div class="ui button submit">${i18n('common.confirm')}</div>
  </div>
</div>`


$('body').append(html);

var layer = $('.transfer-user-layer');
layer.form({
  fields: {
    username: {
      identifier: 'username',
      rules: [{
        type: 'empty',
        prompt: i18n('tip.input.username')
      }]
    }
  },
  onSuccess: function(e, data) {
    var selected = $('.project-list-folder').find('.selected');
    var pid = selected.data('project-id')
    if (!pid) {
      return
    }
    var name = selected.text();


    util.loadData('/project/' + pid + '/transfer/' + data.username, {
      name: name
    }, 'POST', function (res) {
      layer.find('.close').click();
      success(res.data);
    });
  }
});

layer.find('.close').click(function() {
  layer.find('input').val('');
  layer.modal('hide');
});

layer.find('.dropdown.username').dropdown({
  onChange: function(value, text) {}
});

layer.modal({
  onHide: function () {
    layer.form('reset');
  }
});

module.exports = {
  show: function (users, cb) {
    layer.find('.username .menu').html(users.map(function (item) {
      return `<div class="item" data-value="${item.id}">${item.nickname}</div>`
    }).join(''));
    layer.modal('show');
    success = cb;
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/transferUserLayer.js